<button
  type="button"
  class="cads-chip-button"
  [class.cads-chip-button--light-surface]="_usesLightBorder()"
  [ngStyle]="_surfaceStyle()"
  [disabled]="config().disabled ?? false"
  (click)="_onClick()"
>
  <span class="cads-chip-button__inner">
    @if (_leadingIcon(); as leading) {
      <span class="cads-chip-button__icon material-symbols-outlined" aria-hidden="true">{{ leading }}</span>
    }
    <span class="cads-chip-button__label">{{ config().label }}</span>
    @if (_trailingIcon(); as trailing) {
      <span class="cads-chip-button__icon material-symbols-outlined" aria-hidden="true">{{ trailing }}</span>
    }
  </span>
</button>
